var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgRefreshCcw = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9526 13.7437C22.9844 13.8259 23.0002 13.9128 23 13.9996V19.615C23 20.0028 22.6856 20.3171 22.2979 20.3171C21.9101 20.3171 21.5957 20.0028 21.5957 19.615V15.6211L18.4506 18.576C16.2351 20.7927 13.0372 21.7177 9.98047 21.026C6.9237 20.3344 4.43551 18.1229 3.39001 15.1684C3.26065 14.8028 3.45213 14.4016 3.81769 14.2722C4.18325 14.1429 4.58446 14.3343 4.71382 14.6999C5.59848 17.1999 7.70387 19.0712 10.2904 19.6564C12.8769 20.2416 15.5827 19.4589 17.4732 17.568L20.5253 14.7001H16.6809C16.2931 14.7001 15.9787 14.3857 15.9787 13.998C15.9787 13.6102 16.2931 13.2958 16.6809 13.2958H22.2979C22.5926 13.2958 22.845 13.4775 22.9491 13.7349L22.9526 13.7437ZM3.47468 9.55115H7.31915C7.70692 9.55115 8.02128 9.8655 8.02128 10.2533C8.02128 10.6411 7.70692 10.9554 7.31915 10.9554H1.70213C1.40737 10.9554 1.15504 10.7738 1.05094 10.5163C1.01555 10.4253 0.999789 10.3384 1 10.2517V4.63626C1 4.24848 1.31436 3.93413 1.70213 3.93413C2.0899 3.93413 2.40426 4.24848 2.40426 4.63626V8.63018L5.54936 5.67522C7.7649 3.45856 10.9628 2.53358 14.0195 3.22521C17.0763 3.91685 19.5645 6.12837 20.61 9.08288C20.7394 9.44844 20.5479 9.84965 20.1823 9.97901C19.8168 10.1084 19.4155 9.91689 19.2862 9.55133C18.4015 7.05136 16.2961 5.18007 13.7096 4.59485C11.1231 4.00962 8.41725 4.7923 6.52676 6.68325L3.47468 9.55115Z",
    fill: props.color || 'currentColor'
  }));
};
export default SvgRefreshCcw;